export default {
	label: '销售经理',
	id: '0',
	children: [
		{
			label: '岗位定义',
			id: '0-1',
			children: [
				{
					label: '销售经理负责区域或多个区域的销售管理工作，对销售业绩负责',
					id: '0-1-1',
				},
			],
		},
		{
			label: '岗位职责',
			id: '0-2',
			children: [
				{
					label: '制定销售计划和预算，分解销售任务指标',
					id: '0-2-1',
				},
				{
					label: '监控销售过程，发现问题并解决问题',
					id: '0-2-2',
				},
				{
					label: '培训业务人员，进行销售总结和数据分析',
					id: '0-2-3',
				},
				{
					label: '维护客户关系，开发新客户，拓展市场',
					id: '0-2-4',
				},
				{
					label: '参与合同谈判和签订，处理客户投诉',
					id: '0-2-5',
				},
				{
					label: '收集市场信息，分析竞争对手情况',
					id: '0-2-6',
				},
			],
		},
		{
			label: '技能要求',
			id: '0-3',
			children: [
				{
					label: '大专以上学历，5年以上销售经验',
					id: '0-3-1',
				},
				{
					label: '良好的语言表达能力和文字水平',
					id: '0-3-2',
				},
				{
					label: '强大的市场感知能力，敏锐的市场动态把握能力',
					id: '0-3-3',
				},
				{
					label: '良好的客户服务意识和责任心',
					id: '0-3-4',
				},
			],
		},
	]
}